import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  // baseURL = "http://mazzotta-cms-backend-env.eba-vetvvfq6.us-east-1.elasticbeanstalk.com";
  // baseURL= "https://d3omqgrunojhvn.cloudfront.net";
  baseURL= "https://sopro-api.sixlogs.io";
  // baseURL= "https://114f-36-50-13-91.ngrok-free.app";
  // baseURL = "http://localhost:8080"
  constructor() {

  }
}
